export default class Screen {
    constructor(name, uic) {
        this.activateExtension = (extensionName, extensionOptions) => {
            for (let extension of this.extensions) {
                if (extension.name == extensionName) {
                    extension.activate(extensionOptions);
                }
            }
        };
        this.name = name;
        this.uic = uic;
        this.extensions = [];
    }
    deactivateExtensions() {
        for (let extension of this.extensions) {
            extension.deactivate();
        }
    }
    deactivateExtension(extensionName) {
        for (let extension of this.extensions) {
            if (extension.name == extensionName) {
                extension.deactivate();
            }
        }
    }
    resizeExtension() {
        for (let extension of this.extensions) {
            extension.resize();
        }
    }
}
